<template>
  <nav id="nav" class="navbar navbar-expand-md fixed-top py-3">
    <div class="container-lg px-3">
      <a class="navbar-brand me-4" role="button" @click="scrollToTop()">小美祕書</a>
      <button class="navbar-toggler border-0" type="button" @click="clickToggle()">
        <svg fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <line x1="3" x2="21" y1="12" y2="12"/><line x1="3" x2="21" y1="6" y2="6"/><line x1="3" x2="21" y1="18" y2="18"/>
        </svg>
      </button>
      <div class="collapse navbar-collapse" id="navContent">
        <ul class="navbar-nav me-auto mb-3 mb-md-0 align-items-center">
          <li class="nav-item">
            <a class="nav-link" role="button" @click="clickMenu('service')">
              <span class="align-self-center has-animated-underline">服務內容</span>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link" role="button" @click="clickMenu('plan')">
              <span class="align-self-center has-animated-underline">方案選擇</span>
            </a>
          </li> -->
          <li class="nav-item">
            <a class="nav-link" role="button" @click="clickMenu('join')">
              <span class="align-self-center has-animated-underline">立即加入</span>
            </a>
          </li>
        </ul>
        <a @click="toggler.hide(),checkNavBg()" href="https://lin.ee/5DlVwME" target="_blank" rel="noopener" tabindex="-1" role="button" aria-disabled="true"
        class="btn btn-primary rounded-pill text-white px-5 d-block mx-auto mb-3 m-md-0">
          <img class="clickIcon" src="@/assets/img/click.svg" width="30" height="30" />
          <b>加入小美</b>
        </a>
      </div>
    </div>
  </nav>

  <section v-if="$route.name == 'Home'" class="section-head w-100 h-100 flexCenter">
    <div class="col-10 col-lg-8 col-xl-6 py-4 px-3 mx-auto">
      <h1 class="text-primary">小美祕書</h1>
      <h4>您的電商經營得力好幫手！</h4>
    </div>
  </section>
  <section v-if="$route.name == 'Home'" class="text-center">
    <div class="py-5 container" id="service">
      <div class="d-md-flex justify-content-md-start col-md-9 col-xl-7 mx-auto">
        <div class="py-5">
          <h1 class="text-primary">找商品</h1>
          <div class="d-md-flex align-items-center">
            <img class="animate-icon" src="@/assets/img/search.gif" />
            <div class="text-md-start">
              <p class="fs-5.5"><b class="h4">商品文生成</b><br> — 自動編文，商品更賣力！</p>
              <p class="fs-5.5"><b class="h4">短網址服務</b><br> — 縮短連結，分享無負擔！</p>
            </div>
          </div>
        </div>
        <!-- <div class="py-5">
          <h2>商品文生成</h2>
          <img class="animate-icon" src="@/assets/img/shopping-list.gif" />
          <p>自動編文，商品更賣力！</p>
        </div>
        <div class="py-5">
          <h2>縮網址生成</h2>
          <img class="animate-icon" src="@/assets/img/zoom-in.gif" />
          <p>縮短連結，分享無負擔！</p>
        </div> -->
      </div>
      <div class="d-md-flex justify-content-md-end col-md-9 col-xl-7 mx-auto">
        <div class="py-5">
          <h1 class="text-primary">訂單管理</h1>
          <div class="d-md-flex flex-row-reverse align-items-center">
            <img class="animate-icon" src="@/assets/img/clipboard.gif" />
            <div class="text-md-end">
              <p class="fs-5.5"><b class="h4">顧客服務追蹤</b><br> — 自動編文，商品更賣力！</p>
              <p class="fs-5.5"><b class="h4">資料統計分析</b><br> — 自動編文，商品更賣力！</p>
            </div>
          </div>
        </div>
        <!-- <div class="py-5">
          <h2>統計分析</h2>
          <img class="animate-icon" src="@/assets/img/report.gif" />
          <p>自動編文，商品更賣力！</p>
        </div> -->
      </div>
      <div class="col-lg-9 col-xl-7 my-0 my-lg-5 py-5 mx-auto">
        <video class="info_video" controls>
          <source src="@/assets/video/intro.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
    <!-- <div class="py-5 px-3 mx-auto bg-body-tertiary" id="plan">
      <h1 class="mb-4 mb-md-5">方案選擇</h1>
      <div class="flex-table rule mx-auto">
        <div>
          <div class="th"></div>
          <div class="th">基本型</div>
          <div class="th bg-primary-mix-white-80">進階型</div>
        </div>
        <div>
          <div class="td text-start">無限搜尋比價</div>
          <div class="td text-primary"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
          <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div>
          <div class="td text-start">無限短網址轉換</div>
          <div class="td text-primary"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
          <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div>
          <div class="td text-start">自動生成商品文</div>
          <div class="td text-primary"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
          <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div class="pro">
          <div class="td text-start pt-4.5 pb-2"><b>訂單分析管理</b></div>
          <div class="td pt-4.5 pb-2"></div>
          <div class="td text-primary bg-primary-mix-white-80 pt-4.5 pb-2"></div>
        </div>
        <div class="pro">
          <div class="td text-start"><ul class="custom-ul"><li>顧客服務追蹤</li></ul></div>
          <div class="td"></div>
          <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div class="pro">
          <div class="td text-start"><ul class="custom-ul"><li>數據統計分析</li></ul></div>
          <div class="td"></div>
          <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div class="pro">
          <div class="td text-start"><ul class="custom-ul"><li>BV/IBV趨勢圖表</li></ul></div>
          <div class="td"></div>
          <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div class="pro">
          <div class="td text-start"><ul class="custom-ul"><li>暢銷商品分析圖表</li></ul></div>
          <div class="td"></div>
          <div class="td text-primary bg-primary-mix-white-80"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div class="pro">
          <div class="td text-start pb-4.5 border-bottom"><ul class="custom-ul"><li>訂閱期間享有功能升級服務</li></ul></div>
          <div class="td pb-4.5 border-bottom"></div>
          <div class="td text-primary bg-primary-mix-white-80 pb-4.5 border-bottom border-black border-opacity-10"><svg class="icon-check"><use xlink:href="#check"/></svg></div>
        </div>
        <div>
          <div class="td text-start"><b>季付方案</b></div>
          <div class="td lh-1">
            <small>NT$ <b class="fs-4">299</b> / 季</small>
            <br><br><router-link to="/plan" role="button" class="btn btn-primary text-white rounded-pill"><b>我要試用</b></router-link>
          </div>
          <div class="td lh-1 bg-primary-mix-white-80">
            <small>NT$ <b class="fs-4">899</b> / 季</small>
            <br><br><router-link to="/plan" role="button" class="btn btn-primary text-white rounded-pill"><b>我要試用</b></router-link>
          </div>
        </div>
        <div>
          <div class="td text-start"><b>年付方案</b></div>
          <div class="td lh-1">
            <small>NT$ <b class="fs-4">1188</b> / 年<br><b class="small text-danger">加贈1個月</b></small>
            <br><br><router-link to="/plan" role="button" class="btn btn-primary text-white rounded-pill"><b>我要試用</b></router-link>
          </div>
          <div class="td lh-1 bg-primary-mix-white-80">
            <small>NT$ <b class="fs-4">3588</b> / 年<br><b class="small text-danger">加贈1個月</b></small>
            <br><br><router-link to="/plan" role="button" class="btn btn-primary text-white rounded-pill"><b>我要試用</b></router-link>
          </div>
        </div>
      </div>
      <div class="small pt-3 light-mix-black-40">
        * 方案結束後自動續訂<br>
        * 取消訂閱將使用至期間結束
      </div>

    </div> -->
    <div class="py-5 px-3 mx-auto bg-primary text-white" id="join">
      <!-- <h1 class="display-6 mb-3"><b>免費體驗30天 !</b></h1> -->
      <h1>立即加入</h1>
      <div class="QRCode my-4 my-md-5 mx-auto">
        <a class="d-block bg-white bgCenterCover"
        href="https://lin.ee/5DlVwME" target="_blank" rel="noopener"></a>
      </div>
      <p><b>透過行動條碼加入LINE好友</b></p>
      <p class="small">
        請在LINE應用程式上開啟「好友」分頁，點選畫面右上方用來加入好友的圖示，<br>
        接著點選「行動條碼」，然後掃描此行動條碼。
      </p>
      <a class="small text-black-50" href="https://line.me" target="_blank" rel="noopener"
      >進一步瞭解LINE</a>
    </div>
  </section>

  <div v-if="$route.name == 'Content'" class="py-5 px-3 bg-body-tertiary" id="terms">
    <div style="height:2rem;"></div>
    <div class="bg-white rounded w-100 mw-640 mx-auto py-4">
      <terms :type="$route.params.type"></terms>
    </div>
  </div>

  <footer class="footer text-center">
    <p class="small mb-2">
      <b>
        <a role="button" @click="clickMenu('terms')"
        >服務條款</a>・<a role="button" @click="clickMenu('privacy')"
        >隱私權政策</a>
      </b>
    </p>
    <small>Copyright © 2024 Camangi Corp. All rights reserved.</small>
  </footer>

</template>

<script>
import terms from '@/components/termsPrivacy.vue';
import { Collapse } from 'bootstrap';

export default {
  name: 'HomeView',
  components: {
    terms
  },
  data () {
    return {
      isShowMenu: false,
      scrollTimeout: '',
      hashTag: '',
      toggler: ''
    }
  },
  mounted() {
    this.toggler = new Collapse('#navContent', {
      toggle: false
    })
    window.addEventListener('scroll', this.checkNavBg);
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.checkNavBg);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() { // 改變瀏覽尺寸時收起menu
      this.isShowMenu = false;
      this.toggler.hide();
      this.checkNavBg();
    },
    scrollToTop() { // 頁面至頂
      this.$router.push('/')
      window.scrollTo(0,0)
      this.onResize();
    },
    checkNavBg() { // 控制navbar背景色
      var e = document.getElementById("navContent").classList
      if (e.contains("show")) { // navbar展開時
        window.$('#nav').addClass('show')
      } else {
        if (parseInt(window.$("#nav").offset().top) > 0) { // navbar非置頂時
          window.$('#nav').addClass('show')
        } else {
          window.$('#nav').removeClass('show');
        }
      }
    },
    clickToggle() { // 點擊toggler
      var e = document.getElementById("navContent").classList
      if (e.contains("show")) {
        this.isShowMenu = false
        this.toggler.hide();
        if (parseInt(window.$("#nav").offset().top) == 0) { // 首頁置頂時移除navbar背景
          window.$('#nav').removeClass('show');
        }
      } else {
        this.isShowMenu = true
        this.toggler.show();
        window.$('#nav').addClass('show');
      }
    },
    scrollTo(targetElement, delay = 0) { // 执行滚动操作
      this.$nextTick(() => {
        setTimeout(() => {
          // 这段代码将在 Vue 完成 DOM 更新并且过了 delay 毫秒后执行
          const targetRect = targetElement.getBoundingClientRect(); // 取得目標元素位置
          const navbarHeight = document.getElementById("nav").offsetHeight; // 取得navbar高度
          const scrollToY = targetRect.top + window.scrollY - navbarHeight; // 計算滾動位置考慮navbar高度
          window.scrollTo({
            top: scrollToY,
            behavior: "smooth",
          });
        }, delay);
      });
    },
    clickMenu (to) { // 點擊navbar menu
      this.toggler.hide();
      this.hashTag = to

      const targetElement = document.getElementById(to)
      if (targetElement) { // 檢查目標元素是否存在
        if(this.isShowMenu) {
          this.scrollTo(targetElement, 350); // 延迟滚动
        } else {
          this.scrollTo(targetElement); // 立即滚动
        }
      } else {
        if (this.$route.name === 'Content') {
          this.$router.push('/')
        } else {
          this.$router.push({ name: 'Content', params: { type: to } })
        }
      }
      this.isShowMenu = false
    }
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        const targetElement = document.getElementById(this.hashTag)
        if (targetElement) { // 檢查目標元素是否存在
          this.scrollTo(targetElement, 350); // 延迟滚动
        } else {
          this.scrollToTop()
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .footer {
    color: rgba(255,255,255, 0.7);
    background-color: #161617;
    padding: 3rem 1rem;
    a {
      color: rgba(255,255,255, 0.7);
      &:hover,&:focus {color: #FFEB3B;}
    }
  }

  // navbar
  #nav {
    background: none;
    transition: .2s all ease-out;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    font-weight: 700;
    letter-spacing: 1px;
    white-space: nowrap;
    .nav-link {
      width:110px;
      text-align: center;
      .has-animated-underline {
        display: inline-block;
        overflow: hidden;
        margin-top: 3px;
        margin-bottom: -6px;
        &:after {
          display: block;
          width: 100%;
          content: "";
          z-index: 0;
          border-bottom: 3px solid #00a8ca;
          transform: translate3d(-102%,0,0);
          transition: all .25s
        }
      }
      &:hover,&:focus,&.active {
        color: #00a8ca;
        .has-animated-underline:after {transform: translateZ(0)}
      }
    }
    .navbar-toggler {box-shadow: none;}
    &.show {
      background: rgba(#fff, 0.9);
      backdrop-filter: blur(3px);
      border-bottom: 1px solid rgba(#333, 0.1);
    }
    .btn {
      max-width: 188px;
      letter-spacing: 2px;
      .clickIcon {
        margin: -4px 0 0;
        transition: .2s all ease-out;
      }
      &:hover {
        .clickIcon {
          transform: scale(130%);
        }
      }
    }
  }

  .section-head {
    h1 {
      font-size: calc(2.5rem + 1.5vw);
      letter-spacing: 2px;
    }
    background-image :url('@/assets/img/icon1.png');
    background-position: 75% 100%;
    background-repeat: no-repeat;
    background-size: auto 450px;
    background-color: #FFEB3B;
    min-height: 500px;
    @media only screen and (max-width: 900px) {
      background-size: auto 380px;
      background-position: 80% 100%;
      padding-bottom: 60px;
    }
    @media only screen and (max-width: 700px) {
      background-size: auto 360px;
      background-position: 85% 100%;
      padding-bottom: 220px;
    }
    @media only screen and (max-width: 576px) {
      background-size: auto 280px;
      background-position: 50% 100%;
      min-height: 440px;
      padding-bottom: 180px;
      text-align: center;
    }
  }

  .animate-icon {
    margin: 2rem;
    width: 8rem;
    height: 8rem;
    @media only screen and (max-width: 768px) {
      margin: 1rem 0 1.5rem;
      width: 6rem;
      height: 6rem;
    }
    @media only screen and (max-width: 576px) {
      margin: .5rem 0 1.5rem;
      width: 5rem;
      height: 5rem;
    }
  }

  .info_video {
    width: 100%;
    height: 100%;
  }

  .QRCode {
    width: 100%;
    max-width: 300px;
    height: auto;
    @media only screen and (max-width: 428px) {
      max-width: 240px;
    }
    > * {
      width: 100%;
      height: auto;
      padding-top: 100%;
      border-radius: 6%;
      background-image :url('@/assets/img/barcodes.png');
    }
  }

  .flex-table {
    display: table;
    width: 100%;
    > * {display: table-row;}
    .th,.td {
      display: table-cell;
      text-align: center;
      vertical-align: middle;
    }
    &.rule {
      max-width: 600px;
      .th,.td {
        padding: 1.5rem 4px;
        font-size: 1.2rem;
        line-height: 1.75;
        .icon-check {
          width: 36px;
          height: 36px;
        }
        @media only screen and (max-width: 576px) {
          padding: 1rem 4px;
          font-size: 1rem;
          line-height: 1.5;
          .icon-check {
            width: 28px;
            height: 28px;
          }
        }
      }
      .th {
        border-bottom: 1px solid rgba($color: #000, $alpha: .1);
        font-weight: bolder;
      }
      .td {
        border-bottom: 1px solid rgba($color: #000, $alpha: .1);
      }
      .pro {
        >.td {
          padding:.75rem 4px;
          border: none;
          @media only screen and (max-width: 576px) {
            padding:.5rem 4px;
          }
        }
      }
    }
    .note {
      margin-left : .5rem;
      text-indent : -.5rem;
    }
  }
  .plan {
    min-width:180px;
    font-size: 1.2rem;
    @media only screen and (max-width: 576px) {font-size: 1rem;}
  }

  .fs-13 {font-size: 13px;}
</style>
